import $ from '/js/header/jquery.js';
import { MainSearchChangeHelper } from './tools/search/searchHelper/MainSearchChangeHelper.js';

const searchChangeHelper = await new MainSearchChangeHelper().init();

// 사건번호 연도(TOP) 입력 이벤트리스너
$("#num1_Top").on("change", (e) => {
  searchChangeHelper.srchData.sn1 = parseInt(e.target.value);
  $("#sn1").val(parseInt(e.target.value));
});

// 사건번호 상세(TOP) 입력 이벤트리스너
$("#num2_Top").on("input", (e) => {
  // e.target.value = e.target.value.replace(/[^0-9]/g, '');
  $("#sn2").val(e.target.value);
  clearTimeout(searchChangeHelper.timer);
  searchChangeHelper.timer = setTimeout(() => {
  searchChangeHelper.srchData.sn2 = parseInt(e.target.value);
  }, searchChangeHelper.delay);
});

// 시 변경시 이벤트
$('#siCd').on('change', (e) => {
  searchChangeHelper.loadAdrs('sido', e.target.value);
});

// 구 변경시 이벤트
$('#guCd').on('change', (e) => {
  searchChangeHelper.loadAdrs('gugun', e.target.value);
});

// 동 변경시 이벤트
$('#dnCd').on('change', (e) => {
  searchChangeHelper.loadAdrs('dong', e.target.value);
});

// 사건번호(연도) 입력 이벤트리스너
$("#sn1").on("change", (e) => {
  searchChangeHelper.srchData.sn1 = parseInt(e.target.value);
  $("#num1_Top").val(parseInt(e.target.value));
});

// (위험)사건번호 상세 입력 이벤트리스너
$("#sn2").on("input", (e) => {
  $("#num2_Top").val(e.target.value);
  clearTimeout(searchChangeHelper.timer);
  searchChangeHelper.timer = setTimeout(() => {
      searchChangeHelper.srchData.sn2 = parseInt(e.target.value);
  }, searchChangeHelper.delay);
});

// 물건종별 보여주기
$("#ctgr").on("click", (e) => {
  searchChangeHelper.showMainCtgrMulti();
});

document.addEventListener('click', (e) => {
  if (!e.target.closest('#ctgr') && !e.target.closest('#trCtgrMulti')) {
    searchChangeHelper.hideMainCtgrMulti();
  }
});

// 물건종류 복수 - 전체보기 클릭이벤트
$("#chkAllCtgr").on('click', (e) => {
  searchChangeHelper.chkCtgrAll(e.target.checked).srchList();
});

// 물건종별 복수 선택 제어 이벤트
$("input:checkbox[name=chkGrpCtgr]").on("click", (e) => {
  searchChangeHelper.chkCtgrMulti(e.target.id, e.target.checked);
});

// 물건종별 단일선택 제어 이벤트
$("input:checkbox[name=chkEaCtgr]").on("click", (e) => {
  searchChangeHelper.chkCtgrSingle(e.target.value, e.target.checked, e.target.dataset.grpcd);
});
